
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 51.24 50.05"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Ebene_2","data-name":"Ebene 2"}},[_c('g',{attrs:{"id":"Ebene_1-2","data-name":"Ebene 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M0,50.05V0H51.24V50.05Zm48.25-2.91V42.2H8V2.91H3V47.14Zm0-7.85V34.34H16.08V2.91H11V39.29Zm0-7.86V26.49H24.13V2.91H19.07V31.43Zm0-7.85V18.64H32.17V2.91H27.11V23.58Zm0-7.86V2.91H35.15V15.72Z"}})])])])
          )
        }
      }
    